export default __webpack_public_path__ + "static/media/minuteBurger.075af7de.png";